module.exports = require("./../../_gen/openfl/display3D/Program3D");